import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import { motion } from "framer-motion";
import logo from  "./images/logo.png";  // Make sure path is correct
import Home from "./pages/Home";
import Services from "./pages/Services"
import About from "./pages/About";
import Contact from "./pages/Contact";
import Modules from "./pages/Modules"


import "./styles/global.css";
import "./styles/navbar.css";
import "./styles/footer.css";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <nav className="navbar">
      <div className="logo">
      <img className="logo-img" style={{ width: "80px", height: "auto" ,borderRadius:"60px"}} src={logo} alt="ERP Logo" />

      </div>
      <ul className={menuOpen ? "nav-links active" : "nav-links"}>
        <li><Link to="/">Home</Link></li>
        <li><Link to="/services">Services</Link></li>
        <li><Link to="/modules">ERP Modules</Link></li>
        <li><Link to="/about">About Us</Link></li>
        <li><Link to="/contact">Contact Us</Link></li>
      </ul>
      <input type="text" placeholder="Search..." className="search-bar" />
      <button className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>☰</button>
    </nav>
    
  );
};


const PageTemplate = ({ title, content }) => (
  <motion.div className="page-container" initial={{ opacity: 0, y: -50 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
    <h1>{title}</h1>
    <p>{content}</p>
  </motion.div>
);



const App = () => (
  <Router>
    
    <Navbar />
    <Routes>
  <Route path="/" element={<Home />} />
  <Route path="/services" element={<Services />} />
  <Route path="/modules" element={<Modules />} />
  <Route path="/about" element={<About />} />
  <Route path="/contact" element={<Contact />} />
</Routes>


  </Router>
);

export default App;
